import { Colors } from '@nakedplatform/ui';
import { BUTTON_SIZES, BUTTON_TYPES } from 'theme/variants/buttons';
import { fontWeights } from 'theme/variants/fonts';

export const APP_THEME = {
  breakpoints: ['40em', '52em', '64em', '75em', '90em'],
  colors: Colors,
  buttons: BUTTON_TYPES,
  buttonSizes: BUTTON_SIZES,
  fontWeights,
};
